import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const PortoSharedPoliciesIllustration = (props: SVGProps) => {
  const {
    title = 'PortoSharedPoliciesIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="278"
      height="103"
      viewBox="0 0 278 103"
      fill="none"
      {...restProps}
    >
      <title>{title}</title>
      <path
        d="M64.6937 97.2981H54.4355V101.589H64.6937V97.2981Z"
        fill="currentColor"
      />
      <path d="M131.493 98H121.235V102.291H131.493V98Z" fill="currentColor" />
      <path
        d="M28.6178 2.81641L0 98.5079L14.3542 102.801L42.9721 7.10923L28.6178 2.81641Z"
        fill="white"
      />
      <path
        d="M43.038 8.58051V3.57263H144.253V97.9694H43.038V94.6171V8.58051Z"
        fill="currentColor"
      />
      <path
        d="M134.629 12.5157H52.6511V88.2942H134.629V12.5157Z"
        fill="black"
        stroke="black"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M137.811 42.4084H49.479V57.8653H137.811V42.4084Z"
        fill="currentColor"
      />
      <path
        d="M120.24 41.5319C126.95 41.5319 132.391 36.0917 132.391 29.3809C132.391 22.6701 126.95 17.23 120.24 17.23C113.529 17.23 108.089 22.6701 108.089 29.3809C108.089 36.0917 113.529 41.5319 120.24 41.5319Z"
        fill="white"
      />
      <path
        d="M119.878 33.1456C119.878 33.1456 119.543 33.6974 118.672 34.0636C118.151 34.2802 117.434 34.4298 116.48 34.3473C113.937 34.1306 114.009 30.4276 115.113 27.3022C116.217 24.1768 118.409 23.1453 120.992 24.4965C123.571 25.8478 123.236 28.1016 122.823 28.9061C122.411 29.7107 121.689 30.5565 121.209 32.1399C120.729 33.718 123.463 35.3684 123.463 35.3684L117.872 37.2406L118.677 34.0584"
        stroke="black"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M121.147 32.4857C121.147 32.4857 119.595 30.7579 120.255 29.778C120.915 28.7981 120.394 28.1483 120.059 28.5196C119.719 28.8909 119.151 28.2308 119.151 28.2308L118.641 29.4222L114.69 28.7362C114.69 28.7362 115.288 24.4194 117.8 23.9656C120.312 23.5117 122.989 24.1358 123.891 26.3586C125.985 31.5316 121.292 33.1613 121.152 32.4805L121.147 32.4857Z"
        fill="black"
        stroke="black"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M124.85 26.709C126.109 26.709 127.13 25.6884 127.13 24.4294C127.13 23.1704 126.109 22.1498 124.85 22.1498C123.591 22.1498 122.571 23.1704 122.571 24.4294C122.571 25.6884 123.591 26.709 124.85 26.709Z"
        fill="black"
        stroke="black"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M210.956 32.8319C217.667 32.8319 223.107 27.3918 223.107 20.681C223.107 13.9702 217.667 8.53003 210.956 8.53003C204.245 8.53003 198.805 13.9702 198.805 20.681C198.805 27.3918 204.245 32.8319 210.956 32.8319Z"
        fill="white"
      />
      <path
        d="M210.61 22.5071C210.61 22.5071 205.163 25.3231 205.174 21.5169C205.184 18.3296 206.943 15.1475 206.943 15.1475"
        stroke="black"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M208.093 13.2903C207.113 13.9866 205.122 16.7458 210.043 17.6741C210.517 17.7618 212.921 17.0707 211.848 18.3755C210.77 19.6752 210.641 21.3978 210.641 21.3978L211.255 25.4464L211.858 28.7936C211.858 28.7936 225.03 28.2675 216.005 22.7439C213.957 21.4906 211.905 20.7583 213.07 19.7938C214.241 18.8294 216.237 15.1315 213.349 13.4038C211.76 12.4548 209.166 12.527 208.093 13.2903Z"
        fill="black"
        stroke="black"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M208.181 23.5074L208.768 27.3858L212.157 26.8082"
        stroke="black"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M239.92 32.8319C246.631 32.8319 252.071 27.3918 252.071 20.681C252.071 13.9702 246.631 8.53003 239.92 8.53003C233.21 8.53003 227.77 13.9702 227.77 20.681C227.77 27.3918 233.21 32.8319 239.92 32.8319Z"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M183.276 32.8319C189.987 32.8319 195.427 27.3918 195.427 20.681C195.427 13.9702 189.987 8.53003 183.276 8.53003C176.565 8.53003 171.125 13.9702 171.125 20.681C171.125 27.3918 176.565 32.8319 183.276 32.8319Z"
        fill="white"
      />
      <path
        d="M183.508 24.1782C183.508 24.1782 183.173 24.73 182.301 25.0962C181.78 25.3128 181.063 25.4624 180.109 25.3798C177.567 25.1632 177.639 21.4602 178.743 18.3348C179.846 15.2094 182.038 14.1779 184.622 15.5291C187.206 16.8804 186.866 19.1342 186.453 19.9387C186.04 20.7433 185.318 21.5891 184.839 23.1725C184.359 24.7506 187.092 26.401 187.092 26.401L181.502 28.2732L182.306 25.091"
        stroke="black"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M179.33 19.4691C179.33 19.4691 182.218 21.6146 183.611 18.2674C183.611 18.2674 184.859 21.692 186.84 21.6094C188.82 21.5269 189.96 15.338 186.958 13.5896C183.957 11.8412 178.892 12.8005 177.768 17.9167C177.768 17.9167 178.211 19.3917 179.335 19.4743L179.33 19.4691Z"
        fill="black"
        stroke="black"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M256.62 1H166.576C162.993 1 160.088 3.90481 160.088 7.48807V33.9406C160.088 37.5239 162.993 40.4287 166.576 40.4287H256.62C260.203 40.4287 263.108 37.5239 263.108 33.9406V7.48807C263.108 3.90481 260.203 1 256.62 1Z"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M248.555 42.2723L221.302 69.5254L248.555 96.7784L275.808 69.5254L248.555 42.2723Z"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M176.686 72.1062H134.08C125.816 72.1062 119.118 65.408 119.118 57.1443"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M219.224 96.651H160.847V57.7019C160.847 56.6498 161.698 55.7988 162.75 55.7988H217.321C218.373 55.7988 219.224 56.6498 219.224 57.7019V96.651Z"
        fill="black"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M166.34 84.7065H213.727"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M166.34 79.6772H213.727"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M166.34 74.6494H213.727"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M212.02 61.4155H168.047C167.105 61.4155 166.34 62.1787 166.34 63.1201C166.34 64.0615 167.105 64.8246 168.047 64.8246H212.02C212.963 64.8246 213.727 64.0615 213.727 63.1201C213.727 62.1787 212.963 61.4155 212.02 61.4155Z"
        fill="white"
      />
      <path
        d="M212.02 61.4155H168.047C167.105 61.4155 166.34 62.1787 166.34 63.1201C166.34 64.0615 167.105 64.8246 168.047 64.8246H212.02C212.963 64.8246 213.727 64.0615 213.727 63.1201C213.727 62.1787 212.963 61.4155 212.02 61.4155Z"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M248.707 81.5695C255.215 81.5695 260.491 76.2933 260.491 69.7848C260.491 63.2762 255.215 58 248.707 58C242.198 58 236.922 63.2762 236.922 69.7848C236.922 76.2933 242.198 81.5695 248.707 81.5695Z"
        fill="currentColor"
      />
      <path
        d="M242.972 69.5196L247.067 73.6197L254.442 64.5581"
        stroke="white"
        strokeWidth="1.7"
        strokeMiterlimit="10"
      />
      <path
        d="M156.461 101.611C163.257 101.611 168.767 96.1019 168.767 89.3057C168.767 82.5094 163.257 77 156.461 77C149.665 77 144.155 82.5094 144.155 89.3057C144.155 96.1019 149.665 101.611 156.461 101.611Z"
        fill="white"
      />
    </svg>
  );
};
